import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateFloorplanPlacement } from '../services/postCreateFloorplanPlacement.service';

export const createFloorplanPlacement = createAsyncThunk(
  'floorplans/createFloorplanPlacement',
  async (
    { projectId, filePermissionId, floorplanId, x, y },
    { rejectWithValue }
  ) => {
    try {
      const placement = await postCreateFloorplanPlacement(projectId, {
        filePermissionId,
        floorplanId,
        x,
        y,
      });
      return placement;
    } catch (err) {
      return rejectWithValue({ message: err.message });
    }
  }
);
